import {
  shouldMoveMemberToTheCurrentCategory,
  belongToADifferentCategory,
} from '../predicates';
import { getObjectByPath, hasMatchUrlFormatAndKey } from '../utils';
import { pathToKey, pathToTreeKeys } from '../deleteMembers';
import { traverseTree } from '../../traverseTree';
import { updateTree } from '../../updateTree';
import { updateCallbacks } from './updateCallbacks/updateCallbacks';

const getTypeWithNewCategory = (newCategory = '', type = '') =>
  `${newCategory.replace('/', '')}.${type.split('.').slice(1).join('.')}`;

export const updateMemberPathInConfig = (categoryPath, member) => {
  member.path = getTypeWithNewCategory(categoryPath, member.path);
};

/**
 * This visitor is for moving sections/members to some category in the `docsTree`.
 * according to the the menu config (provided in `category` parameter).
 * @param docsTree - the whole tree
 * @param category - the menu config of the relevant category
 */
export const moveMembersToCategories = (docsTree, category) => {
  category.members.forEach((member) => {
    if (shouldMoveMemberToTheCurrentCategory(category.path, member.path)) {
      const [originalCategory, sectionToMove] = member.path.split('.');
      const nodeToMove = getObjectByPath(docsTree, pathToTreeKeys(member.path));
      const lastKey = member.path.split('.').pop();
      if (hasMatchUrlFormatAndKey(nodeToMove, lastKey)) {
        docsTree[pathToKey(category.path)][pathToKey(sectionToMove)] =
          nodeToMove;
        traverseTree(nodeToMove, [
          updateCallbacks(
            docsTree[pathToKey(category.path)],
            docsTree[pathToKey(originalCategory)],
            pathToKey(sectionToMove),
          ),
        ]);
        updateTree(nodeToMove, originalCategory, category.path, false, true);
        delete docsTree[pathToKey(originalCategory)][pathToKey(sectionToMove)];
        updateMemberPathInConfig(category.path, member);
      }
    } else if (belongToADifferentCategory(category.path, member.path)) {
      member.path = getTypeWithNewCategory(category.path, member.path);
    }
  });
};
